import React from "react";
import { useRef } from "react";
import styled from "styled-components";
import { H4 } from "storybook-components/Typography";
import { CalendlyBtn, ModuleOutlineBtn } from "storybook-components/Button";

import PardotForm from 'storybook-components/Pardot/PardotForm';
import Modal from 'storybook-components/Pardot/Modal';

const CtaWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  ${props => props.theme.media.desktopUp`
    flex-direction: column;
    display: flex;
    margin-left: 60px;
    border-radius: 10px;
    padding: 32px 0;
  `};
`;

const StlyedText = styled(H4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.gray1};
  max-width: 200px;
  margin: auto;
`;

const StyledCalendlyButton = styled(CalendlyBtn)`
  text-align: center;
  margin: 16px auto 0;
  background-color: ${({ theme }) => theme.colors.green2};
  padding: 2px 18px;
  p {
    color: ${({ theme }) => theme.colors.green5};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.green3};
  }
`;

const StyledPardotButton = styled(ModuleOutlineBtn)`
  text-align: center;
  margin: 16px auto 0;
  background-color: ${({ theme }) => theme.colors.green2};
  padding: 2px 18px;
  p {
    color: ${({ theme }) => theme.colors.green5};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.green3};
  }
`;

const CtaCard = () => {

  const modalRef = React.useRef();

  return (
    <CtaWrapper>
      <StlyedText>Get started with Mode</StlyedText>
      {/* <StyledCalendlyButton buttonType="ModulePrimary">Schedule a demo</StlyedCalendlyButton> */}
      <StyledPardotButton buttonType="ModulePrimary" onClick={() => {modalRef.current.openModal()}}>Schedule a demo</StyledPardotButton>
      <Modal ref={modalRef}>
        <div>
          <PardotForm config={JSON.stringify({
              "id": "global-demo-blog",
              "styleOverrides": ".suffix {color: white;}.form .submit_button{background-color: #D7EE8A; color: #000;}.form {padding: 15px 0;}",
              "embedContext": "page",
              "styleOverrides": ".suffix {color: white;}.form .submit_button{background-color: #D7EE8A; color: #000;}",
              "formUrl": "https://go.thoughtspot.com/l/710713/2023-09-22/b3tn7",
              "sharedConfigs": "mode_request_demo"
            })} heading={''}></PardotForm>
        </div>
      </Modal>
    </CtaWrapper>
  );
};

export default CtaCard;
